import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Spinner from '../components/Spinner';
import CopySettingsView from '../components/copySettings/CopySettings';
import ErrorPage from '../errors/ErrorPage';
import { getOrder } from '../actions/orderActions';
import { getPlacement, copySettings } from '../actions/placementActions';
import { TrackingCtx  } from "../tracking";
import {toast} from "react-toastify";

export class CopySettings extends Component {

  state = {
    targets: []
  }

  componentDidMount() {
    const { placement, match, dispatch, order } = this.props;
    const ioId = match.params.id;
    const id = match.params.pid;
    if (isEmpty(placement) && id) {
      dispatch(getPlacement(id));
    }
    if (isEmpty(order) && ioId) {
      dispatch(getOrder(ioId))
      .then(() => {
        this.setTargets();
      });
    } else {
      this.setTargets();
    }
    this.pubType = '';
  }

  setTargets = targets => {
    if (isEmpty(targets)) {
      targets = this.getTargets() || [];
    }
    this.setState({ targets });
  }

  getTargets = () => {
    const { order, match } = this.props;
    if (isEmpty(order)) {
      return [];
    }
    const id = parseInt(match.params.pid, 10);
    return order.Placements.filter(p => p.id !== id);
  }

  findCompatiblePlacements = () => {
    const { placement } = this.props;
    const { targets } = this.state;
    return targets.filter(t => {
      if (t.Strategy && placement.Strategy) {
        return t.Strategy.RequiredDetailTypeId === placement.Strategy.RequiredDetailTypeId;
      }
      return false;
    });
  }

  handleStrategyDetails = (field, isChecked) => {
    let { targets } = this.state;
    if (isChecked) {
      targets = this.findCompatiblePlacements();
    } else {
      targets = this.getTargets();
    }
    this.setTargets(targets);
  }

  copy = (targets, settings) => {
    const { dispatch, match, history } = this.props;
    const orderId = match.params.id;
    const placementId = match.params.pid;
    let message = 'Copying settings. This might take a while...';
    toast.info(message, { theme: 'colored', toastId: message });
    dispatch(copySettings(placementId, targets, settings)).then(() => {
      if (this.props.error) {
        return;
      }
      message = 'Successfully copied settings';
      toast.success(message, { theme: 'colored', toastId: message });
      dispatch(getOrder(orderId)).then(() => {
        history.push(`/ios/${orderId}`);
      });
    });
  }

  goBack = () => {
    const { history, placement } = this.props;
    history.push(`/ios/${placement.IoId}/placement/${placement.id}`)
  }

  checkForPubs = (placement) => {
    if (!placement.SalesProduct || !placement.SalesProduct.name) {
      this.pubType = '';
      return;
    }
    if (placement.SalesProduct.name.slice(0, 3) === 'HDM' ||
      placement.SalesProduct.name === 'Automotive Consumer Targeting') {
      this.pubType = 'HDM';
    } else if (placement.SalesProduct.name.slice(0, 4) === 'CDRT') {
      this.pubType = 'CDRT';
    } else {
      this.pubType = '';
    }
  };

  filter = () => {};

  render() {
    const { placement, isFetching, error } = this.props;
    const { targets } = this.state;
    if (placement && placement.SalesProduct && placement.Pubs) this.checkForPubs(placement);
    return (
      <div>
        {isFetching && <Spinner />}
        {!isFetching && error && isEmpty(placement) && (
          <ErrorPage error={error} entity="placement" />
        )}
        {!isFetching && !isEmpty(placement) && (
        <TrackingCtx.Provider value={{category:"Placement", action:"Copy Placement Settings", label:`IO#${placement.IoId} Placement#${placement.id}`}}>
        <CopySettingsView
          placement={placement}
          targets={targets}
          onBack={this.goBack}
          onCopy={this.copy}
          onFilter={this.pubType ? this.filterPubs : this.filter}
          onStrategyDetails={this.handleStrategyDetails}
          pubSelect={this.pubType}
        />
        </TrackingCtx.Provider>
        )}
      </div>
    )
  }
}

CopySettings.defaultProps = {
  placement: null
}

CopySettings.propTypes = {
  placement: PropTypes.object
}

const mapStateToProps = state => {
  const {
    orderRequest,
    placementRequest
  } = state;

  return {
    order: orderRequest.order,
    error: placementRequest.error || orderRequest.error,
    placement: placementRequest.placement,
    isFetching: placementRequest.isFetching || orderRequest.isFetching
  }
}

export default connect(mapStateToProps)(CopySettings);
